'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = require('../../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoggedIn = require('./LoggedIn.scss');

var _LoggedIn2 = _interopRequireDefault(_LoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedIn = function (_Component) {
    (0, _inherits3.default)(LoggedIn, _Component);

    function LoggedIn(props, context) {
        (0, _classCallCheck3.default)(this, LoggedIn);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedIn.__proto__ || (0, _getPrototypeOf2.default)(LoggedIn)).call(this, props, context));

        _this.logOut = function () {
            _this.props.logOutBidder();
        };

        _this.state = {
            mobile: props.mobile && props.mobile === 'phone'
        };
        return _this;
    }

    (0, _createClass3.default)(LoggedIn, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.windowWidth !== nextProps.windowWidth) {
                if (nextProps.windowWidth < 768 && !this.state.mobile) {
                    this.setState({ mobile: true });
                }
                if (nextProps.windowWidth >= 768 && this.state.mobile) {
                    this.setState({ mobile: false });
                }
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['windowWidth']) || (0, _propsComparer2.default)(this.state, nextState, ['mobile']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                parent = _props.parent,
                whiteLabel = _props.whiteLabel;
            var mobile = this.state.mobile;


            var links = [];
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/saved-items'
            }, 'saved-items', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'saved_items'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/my-bids'
            }, 'my-bids', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'my_bids'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/my-auctions'
            }, 'my-auctions', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'my_auctions'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/won-items'
            }, 'won-items', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'won_items'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/messages'
            }, 'messages', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'messages'
            })));
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/dashboard/search-and-alerts/'
                }, 'search-and-alerts', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'saved_searches_and_alerts'
                })));
            }
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/dashboard/followed-auctioneers'
                }, 'followed-sellers', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'followed_auctioneers'
                })));
            }
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/profile'
            }, 'profile', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'account_settings'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default['log-out'],
                onClick: this.logOut
            }, 'log-out', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'log_out'
            })));

            var title = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'me'
            });

            return (0, _jsx3.default)('div', {
                className: _LoggedIn2.default['logged-in']
            }, void 0, !mobile && links.splice(0, 2), (0, _jsx3.default)(_components.DropDownMenu, {
                links: links,
                mobile: this.props.mobile,
                dropdownClass: _LoggedIn2.default['me-button'],
                parent: parent,
                placement: 'bottom',
                popoverClass: _LoggedIn2.default.popover,
                title: title,
                titleClass: _LoggedIn2.default.me
            }));
        }
    }]);
    return LoggedIn;
}(_react.Component);

exports.default = LoggedIn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Login/LoggedIn.js
// module id = g19V
// module chunks = 57